var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Warning', {
    staticClass: "text-body-2 mb-4",
    attrs: {
      "type": _vm.type,
      "border": "left",
      "colored-border": "",
      "color": _vm.defaultColor,
      "elevation": _vm.elevation,
      "icon": _vm.icon || 'info'
    }
  }, [_vm._t("default"), _c('template', {
    slot: "button"
  }, [_vm._t("button")], 2)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }